import { URLParams } from '@/munio/http'
import { CollectionResponse } from './data'
import { Api } from './base'

import Access from './Access'
import Approvals from './Approvals'
import Approval from './Approval'
import Auth from './Auth'
import Attempt from './Attempt'
import Companies from './Companies'
import Users from './Users'
import CompanyCourse from './CompanyCourse.js'
import Course from './Course'
import Courses from './Courses'
import CurrentUser from './CurrentUser.js'
import Departments from './Departments.js'
import DynamicImageGroup from './DynamicImageGroup.js'
import UserImport from './UserImport'
import Integration from './Integration'
import Link from './Link.js'
import Locations, { Location } from './Location.js'
import Mobile from './Mobile.js'
import OAuth from './OAuth'
import Role from './Role.js'
import Roles from './Roles'
import Shop from './Shop.js'
import User from './User.js'
import UserInvite from './UserInvite.js'
import Salesorders from './Salesorders.js'
import Salesorder from './Salesorder.js'
import { AuditContext, AuditResourceDto } from './data/AuditResource.dto'

export class WebApi extends Api {
  get access() {
    return new Access()
  }

  get approvals() {
    return new Approvals()
  }

  approval(id: number) {
    return new Approval(id)
  }

  attempt(id: number) {
    return new Attempt(id)
  }

  audits(context?: AuditContext, options?: URLParams) {
    const url = context ? this.$route('api.web.audits.context', context) : this.$route('api.web.audits')

    return this.$http.get<CollectionResponse<AuditResourceDto>>(url, this.$query(options))
  }

  get auth() {
    return new Auth()
  }

  checkEmail(email: string) {
    return this.$get(this.$route('api.web.admin.check.email', { email }))
  }

  get companies() {
    return new Companies()
  }

  companyCourse(id: string) {
    return new CompanyCourse(id)
  }

  countries() {
    return this.$get(this.$route('api.web.countries'))
  }

  course(id: number) {
    return new Course(id)
  }

  get courses() {
    return new Courses()
  }

  get currentUser() {
    return new CurrentUser()
  }

  get departments() {
    return new Departments()
  }

  durationSeconds(seconds: number) {
    seconds = Math.round(seconds)

    return this.$get(this.$route('api.web.admin.duration.seconds', { seconds }))
  }

  get import() {
    return new UserImport()
  }

  integration(id: number) {
    return new Integration(id)
  }

  dynamicImage(group: string) {
    return new DynamicImageGroup(group)
  }

  get link() {
    return new Link()
  }

  get locations() {
    return new Locations()
  }

  location(id: string) {
    return new Location(id)
  }

  mobile(number: string) {
    return new Mobile(number)
  }

  get oauth() {
    return new OAuth()
  }

  role(id: string) {
    return new Role(id)
  }

  get roles() {
    return new Roles()
  }

  get salesorders() {
    return new Salesorders()
  }

  salesorder(id: string | number) {
    return new Salesorder(id)
  }

  shop(slug: string | { slug: string } = window.Munio.config.shop.slug, context?: string) {
    return new Shop(slug, context)
  }

  get users() {
    return new Users()
  }

  user(id: string | number) {
    return new User(id)
  }

  userInvite(id: string | number) {
    return new UserInvite(id)
  }
}

window.Munio.api = new WebApi()
